import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import Pagination from "../Pagination/Pagination";
import { vendorDashboardQuestionerTotal, vendorQuestionerDashboard } from "../../actions/riskManagement";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isValid } from "date-fns";
import axios from "axios";

const icons = {
  received: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.7 4.3L16.7 19.3C16.4 20.3 15 20.5 14.4 19.6L10.8 14.3L5.5 10.7C4.6 10.1 4.8 8.7 5.8 8.4L20.8 3.4C21.7 3 22.1 3.4 21.7 4.3Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.8 14.3L21.7 4.3" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  unseen: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 4L20 20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M14 14.2361C13.4692 14.7111 12.7684 15 12 15C10.3431 15 9 13.6569 9 12C9 11.2316 9.28885 10.5308 9.76389 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M19.6078 15.6077C17.7796 17.1918 15.0167 18 12 18C7 18 3 12 3 12C3 12 5.01574 8.79334 8.11862 6.88862" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M21 12C21 12 20.1843 13.4367 18.8516 14.8516" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M12 9C13.6569 9 15 10.3431 15 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  inReview: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  complete: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  overdue: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M12 7V13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="12" cy="16" r="1" fill="currentColor"/>
    </svg>
  ),
  approved: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M20 7L12 4L4 7V11C4 14.3137 6.46819 18.4411 11.9999 20C17.5318 18.4411 20 14.3137 20 11V7Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  rejected: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" strokeWidth="1.5" />
      <path d="M9 15L15 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 15L9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  incomplete: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" strokeWidth="1.5" />
      <path d="M8 12H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  search: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M21 21L17 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
};

const VendorQuestionnaireDashboard = () => {
  const dispatch = useDispatch();
  const id = useSelector((state) => {
    return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
  });
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(1);
  const totalCount = useSelector((state) => state?.riskManagement?.vendorTotalDashboard?.data);
  const data = useSelector((state) => state?.riskManagement?.vendorQuestionnaireList);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [status, setStatus] = useState('');

  // Add these state variables to handle the date objects
  const [startDateObj, setStartDateObj] = useState(null);
  const [endDateObj, setEndDateObj] = useState(null);

  // Update startDateObj and endDateObj whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setStartDateObj(new Date(startDate));
    }
    if (endDate) {
      setEndDateObj(new Date(endDate));
    }
  }, [startDate, endDate]);


  useEffect(() => {
    if (id) {
      vendorQuestionerDashboard(id, dispatch, page, search, startDate, endDate, status, pageSize)
    }
  }, [id, page, search, startDate, endDate, status, pageSize])

  useEffect(() => {
    if (id) {
      vendorDashboardQuestionerTotal(id, dispatch)
    }
  }, [id])

  useEffect(() => {
    setTotalItems(data?.data?.totalQuestions)
  }, [data?.data?.totalQuestions])

  const handleStatusFilter = (newStatus) => {
    setStatus(newStatus === status ? '' : newStatus);
    setPage(1);
  };

  const clearFilters = () => {
    setSearch('');
    setStartDate('');
    setEndDate('');
    setStatus('');
    setPage(1);
  };


  const labels = ["Total Leaked Credentials", "Total Third Party Credentials", "Total Combo Credentials"];

  // Add these new state variables
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [tempStartDate, setTempStartDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);

  // Update tempStartDate and tempEndDate whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setTempStartDate(new Date(startDate));
    }
    if (endDate) {
      setTempEndDate(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Add this new function to format the displayed date range
  const formatDateRange = () => {
    if (startDate && endDate) {
      return `Selected date: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''} to ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    } else if (startDate) {
      return `From: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''}`;
    } else if (endDate) {
      return `Till: ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    }
    return "Select date range"; // Default placeholder text
  };

  // Add this function to handle applying the selected date range
  const applyDateRange = () => {
    if (tempStartDate) {
      setStartDate(format(tempStartDate, 'yyyy-MM-dd'));
    } else {
      setStartDate('');
    }

    if (tempEndDate) {
      setEndDate(format(tempEndDate, 'yyyy-MM-dd'));
    } else {
      setEndDate('');
    }

    setDatePickerOpen(false);
    setPage(1);
  };

  // Update the cancelDateSelection function to clear all dates
  const cancelDateSelection = () => {
    // Clear all date states when cancel is clicked
    setTempStartDate(null);
    setTempEndDate(null);
    setStartDate('');
    setEndDate('');
    setStartDateObj(null);
    setEndDateObj(null);
    setDatePickerOpen(false);
  };

  // Add these new state variables for AI modal
  const [aiModalOpen, setAiModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState("");

  // Function to handle file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if file is excel
      if (
        file.type === "application/vnd.ms-excel" ||
        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        setSelectedFile(file);
        setUploadError("");
      } else {
        setUploadError("Please upload only Excel files (.xls or .xlsx)");
        setSelectedFile(null);
      }
    }
  };

  // Function to handle upload and process the file
  const handleUpload = async () => {
    if (!selectedFile) {
      setUploadError("Please select a file first");
      return;
    }

    setIsUploading(true);
    setUploadError("");

    try {
      const formData = new FormData();
      formData.append("questioner_form_excel", selectedFile);

      const response = await axios.post(
        "https://api.brandsek.com/api/tprm/66866ae9072369beb8721c48/answer-policy-questions-excel",
        formData,
        {
          responseType: "blob",
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Create a download link for the response
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `questionnaire_responses_${new Date().toISOString().slice(0, 10)}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Close modal after successful download
      setAiModalOpen(false);
      setSelectedFile(null);
    } catch (error) {
      // console.error removed
      setUploadError("Error processing file. Please try again.");
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="container-fluid risk-dashboard">
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1 className="welcome-text">Third Party Risk Management</h1>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/" className="welcome-textSmall">Dashboard</Link>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="body">
          <div className="row mb-4">
            <div className="col-md-12">
              <div className="d-flex flex-wrap align-items-center w-100 gap-3">
                <div className="stat-card" onClick={() => handleStatusFilter('received')}>
                  <div className="mr-3 d-flex align-items-center">
                    <div className="icon-container mr-3">
                      {icons.received}
                    </div>
                    <div>
                      <span className="d-block h4 mb-0 font-weight-bold">{totalCount?.totalReceivedQuestionForms}</span>
                      <span className="text-muted">Received</span>
                    </div>
                  </div>
                </div>

                <div className="stat-card" onClick={() => handleStatusFilter('unseen')}>
                  <div className="mr-3 d-flex align-items-center">
                    <div className="icon-container mr-3">
                      {icons.unseen}
                    </div>
                    <div>
                      <span className="d-block h4 mb-0 font-weight-bold">{totalCount?.totalUnseenQuestionForms}</span>
                      <span className="text-muted">Not seen yet</span>
                    </div>
                  </div>
                </div>

                <div className="stat-card" onClick={() => handleStatusFilter('in_review')}>
                  <div className="mr-3 d-flex align-items-center">
                    <div className="icon-container mr-3">
                      {icons.inReview}
                    </div>
                    <div>
                      <span className="d-block h4 mb-0 font-weight-bold">{totalCount?.totalInProgressQuestionForms}</span>
                      <span className="text-muted">Still in review</span>
                    </div>
                  </div>
                </div>

                <div className="stat-card" onClick={() => handleStatusFilter('complete')}>
                  <div className="mr-3 d-flex align-items-center">
                    <div className="icon-container mr-3">
                      {icons.complete}
                    </div>
                    <div>
                      <span className="d-block h4 mb-0 font-weight-bold">{totalCount?.totalCompletedQuestionForms}</span>
                      <span className="text-muted">Complete</span>
                    </div>
                  </div>
                </div>

                <div className="stat-card" onClick={() => handleStatusFilter('overdue')}>
                  <div className="mr-3 d-flex align-items-center">
                    <div className="icon-container mr-3">
                      {icons.overdue}
                    </div>
                    <div>
                      <span className="d-block h4 mb-0 font-weight-bold">{totalCount?.totalOverdueQuestionForms}</span>
                      <span className="text-muted">Overdue</span>
                    </div>
                  </div>
                </div>

                <div className="stat-card" onClick={() => handleStatusFilter('approved')}>
                  <div className="mr-3 d-flex align-items-center">
                    <div className="icon-container mr-3">
                      {icons.approved}
                    </div>
                    <div>
                      <span className="d-block h4 mb-0 font-weight-bold">0</span>
                      <span className="text-muted">Approved</span>
                    </div>
                  </div>
                </div>
                {/* Incomplete */}
                <div className="stat-card" onClick={() => handleStatusFilter('incomplete')}>
                  <div className="mr-3 d-flex align-items-center">
                    <div className="icon-container mr-3">
                      {icons.incomplete}
                    </div>
                    <div>
                      <span className="d-block h4 mb-0 font-weight-bold">{totalCount?.totalIncompleteQuestionerForms || 0}</span>
                      <span className="text-muted">Incomplete</span>
                    </div>
                  </div>
                </div>

                <div className="stat-card" onClick={() => handleStatusFilter('rejected')}>
                  <div className="mr-3 d-flex align-items-center">
                    <div className="icon-container mr-3">
                      {icons.rejected}
                    </div>
                    <div>
                      <span className="d-block h4 mb-0 font-weight-bold">{totalCount?.totalRejectedQuestionForms}</span>
                      <span className="text-muted">Rejected</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <div className="searchBoxInput p-0 mx-1">
                <input
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="Search"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1);
                  }}
                />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="date-picker-container">
                <div className="date-range-input">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Select date range"
                    value={formatDateRange()}
                    onClick={() => setDatePickerOpen(true)}
                    readOnly
                  />
                  <span className="calendar-icon">
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="table-responsive table-risk mt-3">
            <table className="table table-custom spacing5 mb-0">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Assessment Campaign</th>
                  <th>Organization Requested</th>
                  <th>Due Date</th>
                  <th>Created At</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.data?.questions?.map((vendor, index) => (
                  <tr key={vendor?._id}>
                    <td>{vendor?._id}</td>
                    <td>{vendor?.formTitle}</td>
                    <td>{vendor?.assignerOrganisationName || 'N/A'}</td>
                    <td>
                      {moment(vendor?.dueDate).isBefore(moment()) ? (
                        <span className="overdue-date d-flex align-items-center">
                          <svg
                            className="mr-1"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#dc3545"
                            strokeWidth="2"
                          >
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="8" x2="12" y2="12" />
                            <line x1="12" y1="16" x2="12" y2="16" />
                          </svg>
                          <span style={{ color: '#dc3545', fontWeight: '500' }}>
                            {moment(vendor?.dueDate).format("DD-MM-YYYY")} (Overdue)
                          </span>
                        </span>
                      ) : (
                        <span>
                          {moment(vendor?.dueDate).format("DD-MM-YYYY")}
                        </span>
                      )}
                    </td>
                    <td>
                      {moment(vendor?.createdAt).format("DD-MM-YYYY")}
                    </td>
                    <td>
                      {vendor?.status === "pending" ? (
                        <span className="status-text status-pending d-flex align-items-center">
                          <svg className="stat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline>
                          </svg>
                          <span className="ml-2">Pending</span>
                        </span>
                      ) : vendor?.status === "unseen" ? (
                        <span className="status-text status-unseen d-flex align-items-center">
                          <svg className="stat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                          </svg>
                          <span className="ml-2">Unseen</span>
                        </span>
                      ) : vendor?.status === "seen" ? (
                        <span className="status-text status-seen d-flex align-items-center">
                          <svg className="stat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M22 2L11 13"></path>
                            <path d="M22 2l-7 20-4-9-9-4 20-7z"></path>
                          </svg>
                          <span className="ml-2">Seen</span>
                        </span>
                      ) : vendor?.status === "rejected" ? (
                        <span className="status-text status-rejected d-flex align-items-center">
                          <svg className="stat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="15" y1="9" x2="9" y2="15"></line>
                            <line x1="9" y1="9" x2="15" y2="15"></line>
                          </svg>
                          <span className="ml-2">Rejected</span>
                        </span>
                      ) : vendor?.status === "approved" ? (
                        <span className="status-text status-approved d-flex align-items-center">
                          <svg className="stat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M20 7L12 4L4 7V11C4 14.3137 6.46819 18.4411 11.9999 20C17.5318 18.4411 20 14.3137 20 11V7Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <span className="ml-2">Approved</span>
                        </span>
                      ) : vendor?.status === "submitted" ? (
                        <span className="status-text status-submitted d-flex align-items-center">
                          <svg className="stat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
                          </svg>
                          <span className="ml-2">Submitted</span>
                        </span>
                      ) : vendor?.status === "incomplete" ? (
                        <span className="status-text status-incomplete d-flex align-items-center">
                          <svg className="stat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" strokeWidth="1.5" />
                            <path d="M8 12H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <span className="ml-2">Incomplete</span>
                        </span>
                      ) : "N/A"}
                    </td>
                    <td>
                      <Link
                        to={`/questionnaire-details/${vendor?._id}`}
                      >
                        Answer Questionnaire
                      </Link>
                      {/* <button
                        className={`btn btn-sm btn-warning mx-1`}
                      >
                        Send Warning
                      </button>
                      <button
                        className={`btn btn-sm btn-info mx-1`}
                      >
                        Reminder
                      </button> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="dataTables_paginate d-flex align-items-center justify-content-between">
            {totalItems > 10 && (
              <div className="d-flex align-items-center">
                <span className="mr-2">Show</span>
                <select
                  className="form-control form-control-sm"
                  style={{ width: '70px' }}
                  value={pageSize}
                  onChange={(e) => {
                    setPageSize(Number(e.target.value));
                    setPage(1);
                  }}
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                <span className="ml-2">entries</span>
              </div>
            )}

            {totalItems > 0 && (
              <Pagination
                className="pagination-bar"
                currentPage={page}
                totalCount={totalItems}
                pageSize={pageSize}
                onPageChange={(page) => setPage(page)}
              />
            )}
          </div>
        </div>
      </div>
      {/* Move date picker outside of the component tree to ensure proper rendering */}
      {datePickerOpen && (
        <div className="date-range-overlay" onClick={() => setDatePickerOpen(false)}>
          <div className="date-range-picker-popup" onClick={(e) => e.stopPropagation()}>
            <div className="date-range-picker-header">
              {tempStartDate && tempEndDate
                ? `Selected date: ${format(tempStartDate, 'MM/dd/yyyy')} to ${format(tempEndDate, 'MM/dd/yyyy')}`
                : "Select date range"}
            </div>
            <div className="date-range-calendars">
              <div>
                <h6>From</h6>
                <DatePicker
                  selected={tempStartDate}
                  onChange={(date) => {
                    setTempStartDate(date);
                    if (tempEndDate && date > tempEndDate) {
                      setTempEndDate(null);
                    }
                  }}
                  selectsStart
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
              <div>
                <h6>To</h6>
                <DatePicker
                  selected={tempEndDate}
                  onChange={(date) => setTempEndDate(date)}
                  selectsEnd
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  minDate={tempStartDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
            </div>
            <div className="date-range-actions">
              <button
                className="date-range-apply"
                onClick={applyDateRange}
              >
                Apply Filter
              </button>
              <button
                className="date-range-cancel"
                onClick={cancelDateSelection}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* AI Questionnaire Modal */}
      {aiModalOpen && (
        <div className="modal-overlay" onClick={() => setAiModalOpen(false)} style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{
            width: '500px',
            backgroundColor: '#fff',
            borderRadius: '8px',
            padding: '20px',
            boxShadow: '0 5px 15px rgba(0,0,0,0.2)'
          }}>
            <div className="modal-header d-flex justify-content-between align-items-center mb-3">
              <h5 className="m-0">Questionnaire AI Assistant</h5>
              <button 
                className="close-btn"
                onClick={() => setAiModalOpen(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer'
                }}
              >
                &times;
              </button>
            </div>
            <div className="modal-body">
              <p>Upload your Excel file with questionnaire data to get AI-powered responses.</p>
              
              <div className="form-group mt-3">
                <label className="d-block p-2" style={{
                  border: '2px dashed #ccc',
                  borderRadius: '5px',
                  textAlign: 'center',
                  padding: '20px',
                  cursor: 'pointer',
                  marginBottom: '15px'
                }}>
                  <input
                    type="file"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                    accept=".xls,.xlsx"
                  />
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#888"
                    strokeWidth="2"
                    style={{ display: 'block', margin: '0 auto 10px' }}
                  >
                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                    <polyline points="17 8 12 3 7 8" />
                    <line x1="12" y1="3" x2="12" y2="15" />
                  </svg>
                  {selectedFile ? selectedFile.name : "Click to browse or drop Excel file here"}
                </label>
                
                {uploadError && (
                  <div className="alert alert-danger py-2" role="alert">
                    {uploadError}
                  </div>
                )}
                
                {selectedFile && (
                  <div className="selected-file d-flex align-items-center justify-content-between p-2 bg-light rounded">
                    <span className="text-truncate" style={{ maxWidth: '300px' }}>
                      {selectedFile.name}
                    </span>
                    <button
                      className="btn btn-sm btn-light p-0"
                      style={{maxWidth:"20px",minWidth:"20px"}}
                      onClick={() => setSelectedFile(null)}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-end mt-3">
              <button
                className="btn btn-round btn-default mr-2"
                onClick={() => setAiModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleUpload}
                disabled={!selectedFile || isUploading}
                style={{
                  backgroundColor: '#08283f',
                  border: 'none'
                }}
              >
                {isUploading ? (
                  <>
                    Processing...
                  </>
                ) : (
                  "Upload & Process"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VendorQuestionnaireDashboard;
